import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "index";
var hizmetKategoriService = {
    hKategoriTanimlama(link, icon, baslik,dil) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                link: link,
                icon:icon,
                baslik: baslik,
                dil: dil,
                serviceName: "hizmet",
                methodName: "hKategoriTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    hKategoriDetay(hkategoriId) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                hkategoriId: hkategoriId,
                serviceName: "hizmet",
                methodName: "hKategoriDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },


    hKategoriListesi(durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                durum: durum,
                dil: "",
                serviceName: "hizmet",
                methodName: "hKategoriListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    hKategoriDurumGuncelle(hkategoriId,durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                hkategoriId:hkategoriId,
                durum: durum,
                serviceName: "hizmet",
                methodName: "hKategoriDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    hKategoriGuncelle(hkategoriId, link, icon, baslik,dil) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                hkategoriId: hkategoriId,
                link: link,
                icon:icon,
                baslik: baslik,
                dil:dil,
                serviceName: "hizmet",
                methodName: "hKategoriGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

}

export default hizmetKategoriService

